import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyAddonTemplate } from "../../../../actions/mods_factory/addonTemplatesActions";
import { useNavigate } from "react-router-dom";
import { selectAddonTemplateEntities, selectAddonTemplateIds, setEditId } from "../../../../store/mods_factory/addonTemplatesSlice";

import { message, Spin } from "antd";
import { LikeOutlined, MessageOutlined } from "@ant-design/icons";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import IconText from "../../../../componets/IconText";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import {formattedDate} from "../../../../helpers/DateHelpers";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const ids             = useAppSelector(selectAddonTemplateIds);
  const addonTemplates  = useAppSelector(selectAddonTemplateEntities);
  const count           = useAppSelector(state => state.modsFactory.addonTemplates.count);
  const error           = useAppSelector(state => state.modsFactory.addonTemplates.error);
  const status          = useAppSelector(state => state.modsFactory.addonTemplates.status);

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAddonTemplate(id));

    if (destroyAddonTemplate.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyAddonTemplate.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderAddonTemplate = (id: EntityId) => {
    const addonTemplate = addonTemplates[id];

    if (!addonTemplate) {
      return;
    }
    const formattedCreatedAt = formattedDate(addonTemplate.created_at);

    return (
      <CardImage
        key={addonTemplate.id}
        image={addonTemplate.thumbnail_url}
        title={addonTemplate.title}
        link={addonTemplate.url}
        stats={[
          <IconText icon={LikeOutlined} text={addonTemplate.likes_count} />,
          <IconText icon={MessageOutlined} text={addonTemplate.comments_count} />
        ]}
        options={[
          <ButtonEdit key={`edit-${addonTemplate.id}`} onClick={() => onClickEdit(addonTemplate.id)} />,
          <ButtonDestroy key={`destroy-${addonTemplate.id}`} onClick={() => onClickDestroy(addonTemplate.id)} />
        ]}>
        <div className='v-small_text'>
          {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderAddonTemplate)}

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
